<template>
  <div class="benefit-item benefit-luggage">
    <table v-if="!isPiece" class="cell-body">
      <tr v-for="(item, index) in list" :key="index">
        <td v-if="(index + 1) % 2 === 1" rowspan="2"  width="10%">
          {{ travalerTypeMap[item.passengerType] }}
        </td>
        <td v-if="(index + 1) % 2 === 1">
          <l8-icon type="icon-life-fi-trunk"></l8-icon> 托运行李
        </td>
        <td v-if="(index + 1) % 2 === 0">
          <l8-icon type="icon-gongjuxiang"></l8-icon> 手提行李
        </td>
        <template v-if="airline === '8L'">
          <td width="35%">{{ item.name }}</td>
          <td width="35%">{{ item.text }}</td>
        </template>
        <template v-else>
          <td width="75%">{{ item.name }}</td>
        </template>
      </tr>
    </table>
    <table v-else class="cell-body">
      <tr v-for="(item, index) in list" :key="index" >
        <td v-if="(index + 1) % 2 === 1" rowspan="2" width="10%">
          {{ travalerTypeMap[item.passengerType] }}
        </td>
        <td v-if="(index + 1) % 2 === 1" rowspan="2">{{ item.data }}件</td>
        <td v-if="(index + 1) % 2 === 1">
          <l8-icon type="icon-base-life-fi-trunk"></l8-icon> 托运行李
        </td>
        <td v-if="(index + 1) % 2 === 0">
          <l8-icon type="icon-base-gongjuxiang"></l8-icon> 手提行李
        </td>
        <td width="75%">{{ item.text }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { travalerTypeMap } from '@/dicts/order'
const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline || ''

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      travalerTypeMap,
      airline
    }
  },
  computed: {
    isPiece () {
      const { list } = this
      const isPiece = list.findIndex(item => { return item.code === 'BAGGAGE-PIECE' }) >= 0
      return isPiece
    }
  }
}
</script>

<style lang="less">
.benefit-luggage {
  .cell-body {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
